
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 6.92494L4.28598 10.7689C3.99192 11.077 3.51461 11.077 3.22055 10.7689C2.92648 10.4608 2.92648 9.96059 3.22055 9.65245L7.49782 5.21827C7.77555 4.92725 8.22516 4.92725 8.50218 5.21827L12.7795 9.65245C13.0735 9.96059 13.0735 10.4608 12.7795 10.7689C12.4854 11.077 12.0081 11.077 11.714 10.7689L8 6.92494Z","fill":"#10001F"}})])
          )
        }
      }
    